<template>
  <div>
    <div v-if="listNotification?.length" class="list-notifications">
      <div
        v-for="item in listNotification"
        :key="item.id"
        class="list-notifications__item"
        :class="{
          new: item.isNew
        }"
      >
        <div class="list-notifications__item-date">
          {{ item.createdAt }}
        </div>
        <span v-if="item.isNew" class="list-notifications__item-label"
          >New</span
        >
        <div class="list-notifications__item-title" v-html="item.title"></div>
      </div>
    </div>
    <NoDataComponent
      v-else-if="!isLoading && !listNotification.length"
      :text="$t('notification.notNotifications')"
    />
  </div>
</template>

<script>
import { NoDataComponent } from "@v2/shared/ui/components";

export default {
  components: { NoDataComponent },
  props: {
    listNotification: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";
.list-notifications {
  margin-bottom: 26px;
  background: #ffffff;
  border: 1px solid #f1f1f1;
  box-sizing: border-box;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.057971);

  &__item {
    position: relative;
    padding: 22px 80px;

    @include respond-down(lg) {
      padding-left: 40px;
      padding-right: 40px;
    }
    @include respond-down(sm) {
      padding: 22px 20px;
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 80px;
      right: 80px;
      bottom: 0;
      height: 1px;
      background-color: #cdced0;

      @include respond-down(lg) {
        left: 40px;
        right: 40px;
      }
      @include respond-down(sm) {
        left: 20px;
        right: 20px;
      }
    }
    &:last-child {
      padding-bottom: 42px;
      border-bottom: none;

      @include respond-down(sm) {
        padding-bottom: 35px;
      }
      &:after {
        display: none;
      }
    }
    &.new {
      background-color: #eff8ff;
    }
  }
  &__item-date {
    display: inline-block;
    vertical-align: middle;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #a7a7a7;
  }
  &__item-title {
    display: block;
    margin-top: 8px;
    font-size: 13px;
    line-height: 16px;
    color: #262626;
  }
  &__item-label {
    display: inline-block;
    vertical-align: middle;
    margin-left: 8px;
    padding: 5px 6px;
    background: #005197;
    border-radius: 2px;
    font-weight: 500;
    font-size: 7px;
    line-height: 1;
    text-transform: uppercase;
    text-align: center;
    color: #ffffff;
  }
}
.list-notifications {
  &__item-title {
    .link {
      text-decoration: none;
      cursor: pointer;
      color: #009ee3;
    }
  }
}
</style>
